<template>
  <Container no-padding full-width>
    <Hero v-editable="blok">
      <template #background>
        <NuxtImg v-if="blok.image?.filename" :src="blok.image.filename" width="1280" quality="50" format="webp" />
      </template>
      <h1>
        {{ blok.title }}
      </h1>
      <p>
        {{ blok.teaser }}
      </p>
    </Hero>
  </Container>
  <Container>
    <Button :to="{path: '/over-ons/nieuws'}" icon="ArrowLeft" icon-pos="left" class="h-margin-bottom-xl">
      Nieuws
    </Button>
    <LazySbText v-editable="blok" :blok="blok" />
  </Container>
</template>
<script setup>
import { convert } from 'html-to-text'
const route = useRoute()
const url = useRequestURL()
const { formatNewsItem, formatNewsItemBreadcrumbs } = useHrMeta()
const props = defineProps({ blok: Object, story: Object })
formatNewsItem({ title: props.blok.title, teaser: props.blok.teaser, description: convert(renderRichText(props.blok.text)), image: props.blok.image, url: url.href })
formatNewsItemBreadcrumbs({ name: props.blok.title, url: route.fullPath })
</script>
